import styles from "../../ProductsRPDesigner.module.scss";
import { Button } from "@mui/material";

function GSAttributes({ openAttributesDetail }) {
  return (
    <div className={styles["sec--products--rpdesigner--colors"]}>
      <Button
        id="openAttributes"
        fullWidth
        variant="contained"
        color="primary"
        onClick={openAttributesDetail}
        name="languages"
      >
        Attributes
      </Button>
    </div>
  );
}

export default GSAttributes;
